import AuthLogin from './Login';

export default AuthLogin;
